module.exports = __webpack_public_path__ + "static/media/43.cfdd56dc.JPG";